var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['highlight', { 'is-primary': _vm.isPrimary }],style:(_vm.styles),attrs:{"title":_vm.infoLabel}})}
var staticRenderFns = []

export { render, staticRenderFns }